module.exports = __webpack_public_path__ + "img/Mobile_FullScreen_Button.36d2f871.svg";